import { AuthDomain, useAccount, useProject } from 'auth-lib-front';

import Group = AuthDomain.Object.Group;

const PRODUCT_KEY = 'troppus' as const;

export type Permissions = {
  /** 真のシステム管理者（社内の基盤管理者）。破壊的操作 UI 用。バックエンドの SystemAdmin スコープに対応。 */
  isSystemAdmin: boolean;
  /** 社内メンバー。AdminUI / デバッグ機能用。バックエンドの Employee スコープに対応。 */
  isEmployee: boolean;
  /** 権限グループ上で troppus のプロダクト管理者（isAdmin）。作成・更新・削除・取り込みなどの管理操作 UI 用。バックエンドの ProductAdmin スコープに対応。 */
  isProjectAdmin: boolean;
};

/**
 * troppus フロントの認可判定を一元化するフック。
 * バックエンド（authGuards の AuthGuards）と同じ 3 区分を返す。
 * 「利用可能権限のみ」のユーザーは 3 つとも false になり、参照系のみ閲覧できる。
 */
export function usePermissions(): Permissions {
  const { account } = useAccount();
  const { project } = useProject();

  const group = project.membership?.group;
  const isProjectAdmin = group ? Group.Policy.IsAdmin({ policy: group.policy, productKey: PRODUCT_KEY }) : false;

  return {
    isSystemAdmin: account.isSystemAdmin,
    isEmployee: account.isEmployee,
    isProjectAdmin,
  };
}
